var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td, Box } from "@reverb-ui/react";
import { CaretDown, CaretUp } from "@reverb-ui/icons-react";
import { useTable, useSortBy } from "react-table";
import { useTranslation } from "react-i18next";
export var ContactTable = function (_a) {
    var contacts = _a.contacts;
    var t = useTranslation("my-account").t;
    var data = React.useMemo(function () {
        return contacts.map(function (c) {
            var _a, _b;
            return ({
                name: c.firstName ? c.firstName + " " + c.lastName : "-",
                email: (_a = c.email) !== null && _a !== void 0 ? _a : "-",
                phone: c.phone && c.phone !== "-"
                    ? "+" + ((_b = c.countryCode) === null || _b === void 0 ? void 0 : _b.code) + " " + c.phone
                    : "-",
            });
        });
    }, [contacts]);
    var columns = React.useMemo(function () { return [
        {
            Header: t("company-tab.name"),
            accessor: "name",
        },
        {
            Header: t("company-tab.email"),
            accessor: "email",
        },
        {
            Header: t("company-tab.phone"),
            accessor: "phone",
        },
    ]; }, [t]);
    var _b = useTable({ columns: columns, data: data }, useSortBy), getTableProps = _b.getTableProps, headerGroups = _b.headerGroups, getTableBodyProps = _b.getTableBodyProps, prepareRow = _b.prepareRow, rows = _b.rows;
    return (React.createElement(Table, __assign({}, getTableProps(), { size: "sm", variant: "unstyled" }),
        React.createElement(Thead, null, headerGroups.map(function (headerGroup, index) { return (React.createElement(Tr, __assign({ key: index }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
            return (React.createElement(Th, __assign({ key: column.id }, column.getHeaderProps(column.getSortByToggleProps()), { color: "gray.500", textTransform: "none", fontWeight: 400, fontSize: "14px" }),
                column.render("Header"),
                React.createElement(Box, { pl: "4" }, column.isSorted ? (column.isSortedDesc ? (React.createElement(CaretDown, null)) : (React.createElement(CaretUp, null))) : null)));
        }))); })),
        React.createElement(Tbody, __assign({}, getTableBodyProps()), rows.map(function (row) {
            prepareRow(row);
            return (React.createElement(Tr, __assign({ key: row.id }, row.getRowProps()), row.cells.map(function (cell, index) { return (React.createElement(Td, __assign({ key: index }, cell.getCellProps()), cell.render("Cell"))); })));
        }))));
};
